import { getRequest, getWithParamsRequest, putRequest } from '../utils/provider';
import { ApiResponse } from '../utils/responseTransform';

export async function getAllRiderInstructions(
  queryParams: QueryParams,
  locationId: string,
  signal?: AbortSignal
): Promise<ApiResponse<{ riders: RiderLocationInstructions[]; totalRiderCount: number }>> {
  return getWithParamsRequest(`locations/${locationId}/rider_instructions`, queryParams, signal);
}

export async function getRiderInstructions(
  locationId: string,
  riderSlug: string
): Promise<ApiResponse<RiderLocationInstructions>> {
  return getRequest(`locations/${locationId}/rider_instructions/${riderSlug}`);
}

export async function updateRiderInstructions(payload, locationId: string, riderId: string): Promise<ApiResponse> {
  return putRequest(`locations/${locationId}/rider_instructions/${riderId}`, payload);
}
